import React, { useState } from "react";
import { Container, Row, Col, Modal, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./GetInTouch.css"; 
import Button from "../Button/Button";
import GetInTouchForm from "./GetInTouchForm";

const GetInTouch = ({ heading = "AI That Drives You Forward", headingColMd = 7, buttonColMd = 4, }) => {
  const [showModal, setShowModal] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  return (
    <div className="get-in-touch-banner">
      <Container >
        <Row className="align-items-center justify-content-between">
          {/* Left Side - Heading */}
          {/* <Col xs={12} md={1} className="text-center text-md-end"></Col> */}
          <Col xs={12} md={headingColMd} className="text-center text-md-center">
            <h1 className="get-in-touch-heading">{heading}</h1>
          </Col>
         
          {/* Right Side - Button */}
          <Col xs={12} md={buttonColMd} className="text-center text-md-start">
            <Button variant="light" className="get-in-touch-btn" color="banner" onClick={handleShow}>
              Get in Touch
            </Button>
          </Col>
        
        </Row>
      </Container>

      <GetInTouchForm showModal={showModal} handleClose={handleClose} />
    </div>
  );
};

export default GetInTouch;